module.exports = __webpack_public_path__ + "static/img/v2_pt9s6m.a6d87cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2_pt9s6m.jpg
// module id = mRXO
// module chunks = 2